import { BaselineDetailRequest, ProjectBaseline,ActiveMonthDetails,ProjectBaselineResponse, SaveBaselineResponse } from "../interfaces/baselineInterface";
import {
  React,
  AppLayout,
  useNavigate,
  TableCell,
  TableRow,
  TableBody,
  Table,
  Box,
  CustomButton,
  Grid2,
  Typography,
  TableHead,
  Tooltip,
  SearchIcon,
  CustomDropdown,
  CustomDatePicker,
  SelectChangeEvent,
  useApi,
  SearchBar,
  Toaster,
  Dayjs,
  dayjs,
  Paper,
  GridColDef,
  Chip
} from "../utils/globalImports";
import { FilterListOutlined } from "@mui/icons-material";
import {
  ProjectBaselineStatus,
  ProjectBaselineDescriptions,
  statusColors
} from "../interfaces/baselineInterface";
import CustomDashboardTable from "../components/dataTable/CustomDashboardTable";
import { useState, useEffect } from "react";
import { Stack } from "@mui/material";
import { headingStyles } from "../assets/styles/CommonStyles";

export interface BaselineProjectApproval {
  baselineID: number;
  isSkipBL: boolean;
  isSkipCommercial: boolean;
  projectID: number;
  commercialLeadId?: number | null;
  commercialLeadStatus?: number | null;
  commercialLeadRemarks?: string | null;
  smtId?: number | null;
  smtStatus?: number | null;
  smtRemarks?: string | null;
  isCommercialLead: boolean;
  commercialLeadUpdatedAt?: Date | null;
}
// Models defined on this page
export class ProjectListingFilterModel {
  projectManagerId: number = 0;
  projectNumber?: string | null;
  projectName?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  clientId: number = 0;
  isAdmin: boolean = false;
}

export class ProjectListingModel {

  baselineEndDate?: string;
  baselineStartDate?: string;
  projectId: number = 0;
  projectNumber?: string;
  projectName?: string;
  baselineStatus?: string;
  baselineProjectStatus: number = 0;
  totalChangeDefinite: number = 0;
  totalChangeProposed: number = 0;
  totalChangeThirdParty: number = 0;
  totalChangeOverall?: number;
  clientId?: number;
  clientName?: string;
  projectManagerId?: number;
  projectManagerName?: string;
  startDate?: string | null;
  endDate?: string | null;
}

const sortOptions = [
    { value: "projectNumber", text: "Project No." },
    { value: "projectName", text: "Project Name" },
]
const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { execute, loading } = useApi();

  const userId = Number(localStorage.getItem("userId"));
  const role = localStorage.getItem("role");
  const isAdmin = (role?.toLowerCase() === "admin" || role?.toLowerCase() === "smt");
  const isCommercial = role?.toLowerCase() === "commercial";
  const isSMT = role?.toLowerCase() === "smt";

  const isProjectManager = role?.toLowerCase() === "project manager";
  const isAllowAcessProjects = isCommercial || isAdmin;
  const today = new Date();

  const [currentBaseline, setCurrentBaseline] = useState<ProjectBaseline | null>(null);
  const [toast, setToast] = useState({
    open: false,
    message: "",
    type: "success",
  });
  // Filters state
  const [filters, setFilters] = useState({
    projectManagerId: "-1",
    projectNumber: "-1",
    projectName: "-1",
    clientId: "-1",
    startDate: null as Date | null,
    endDate: null as Date | null,
  });

  const [projectList, setProjectList] = useState<ProjectListingModel[]>([]);
  const [searchQuery, setSearchQuery] = useState(""); // single search bar
  const [searchExecuted, setSearchExecuted] = useState(false);

  const handleViewBaseline = async () => {
    try {
      let newBaselineId = 0;
      if (currentBaseline !== null) {
        newBaselineId = currentBaseline?.id ?? 0;
        if (newBaselineId > 0) {
          navigate("/view-baseline", {
            state: {
              currentBaselineId: newBaselineId, // ✅ Pass baseline ID
              projectManagerID: currentBaseline?.projectManagerID
            },
          });
        }
      }
    } catch (error) {
      console.error("Error in creating baseline", error);
      setToast({
        open: true,
        message: "Something went wrong while skipping the baseline.",
        type: "error",
      });
    }
  };
  const handleSkip = async (type: "BL" | "CBL") => {

    if (!currentBaseline || currentBaseline.id === 0) {
      setToast({
        open: true,
        message: "No baseline found to skip.",
        type: "error",
      });
      return;
    }

    try {

      // ✅ Prepare dynamic flags based on skip type
      const isSkipBL = type === "BL";
      const isSkipCommercial = type === "CBL";
      // 🔹 Create payload for Skip BL API
      const payload: BaselineProjectApproval = {
        baselineID: currentBaseline.id,
        isSkipBL,
        isSkipCommercial,
        projectID: 0,
        isCommercialLead: false,
        commercialLeadId: null,
        commercialLeadStatus: null,
        commercialLeadRemarks: "",
        smtId: null,
        smtStatus: null,
        smtRemarks: "",
        commercialLeadUpdatedAt: null,
      };

      console.log("payload", payload)
      // 🔹 Call API
      const { data } = await execute("put", "/ProjectBaseline/UpdateBaseline", payload);

      if (data) {
        setToast({
          open: true,
          message: "Baseline skipped successfully!",
          type: "success",
        });
        // Optionally refresh current baseline
        await fetchCurrentBaseline(currentBaseline.projectManagerID);
      } else {
        setToast({
          open: true,
          message: "Failed to skip baseline. Please try again.",
          type: "error",
        });
      }
    } catch (error) {
      console.error("Error skipping baseline:", error);
      setToast({
        open: true,
        message: "Something went wrong while skipping the baseline.",
        type: "error",
      });
    }
  };



  const [dropdownOptions, setDropdownOptions] = useState({
    projectNumbers: [] as { value: string; text: string }[],
    projectNames: [] as { value: string; text: string }[],
    clients: [] as { value: number; text: string }[],
    projectManagers: [] as { value: number; text: string }[],
  });


  // Handle filter changes
  const handleFilterChange = (key: string, event: SelectChangeEvent<string | number> | any) => {
    const value = event.target ? event.target.value : event;
    setFilters((prev) => ({ ...prev, [key]: value }));
    setSearchExecuted(false);
  };


  // Helper to format date as yyyy-MM-dd
  const formatDate = (date: any): string | null => {
    if (!date) return null;

    // 🧠 If it’s a Day.js object (from MUI DatePicker)
    if (date.$d) date = date.$d;

    // 🧠 If it's a string, try converting to Date
    if (typeof date === "string") date = new Date(date);

    // 🧠 If still not a valid Date
    if (!(date instanceof Date) || isNaN(date.getTime())) return null;

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  };

  const isWithinBaselineWindow = (): boolean => {
    const today = new Date();
    const day = today.getDate();
    return day < 1 && day < 31;
  };
  const handleClearFilters = async () => {
    setSearchQuery("");
    const defaultFilters = {
      projectManagerId: "-1",
      projectNumber: "-1",
      projectName: "-1",
      clientId: "-1",
      startDate: null,
      endDate: null,
    };
    setSearchExecuted(false);
    setFilters(defaultFilters);
    // Fetch default data (same as page load)
    const payload: ProjectListingFilterModel = {
      //projectManagerId: userId,
      projectManagerId: isProjectManager ? userId : 0,
      projectNumber: null,
      projectName: null,
      startDate: null,
      endDate: null,
      clientId: 0,
      isAdmin: isAllowAcessProjects,
    };

    try {
      const { data } = await execute("post", "Dashboard/GetProjectListing", payload);
      if (data && Array.isArray(data)) {
        setProjectList(
          data.map((item: any) => ({
            baselineStartDate: item.baselineStartDate,
            baselineEndDtae: item.baselineEndDate,
            projectId: item.projectId,
            projectNumber: item.projectNumber,
            projectName: item.projectName,
            projectManagerId: item.projectManagerId,
            projectManagerName: item.projectManagerName,
            totalChangeDefinite: item.totalDefiniteChange,
            totalChangeProposed: item.totalProposedChange,
            totalChangeThirdParty: item.totalThirdPartyChange,
            totalChangeOverall: item.totalDefiniteChange + item.totalProposedChange,
            baselineProjectStatus: item.baselineProjectStatus,
            baselineStatus: item.baselineStatus,
            clientId: item.clientId,
            clientName: item.clientName,
            startDate: item.startDate,
            endDate: item.endDate
          }))

        );
      } else {
        setProjectList([]);
      }

    } catch (error) {
      console.error("Error fetching project listing", error);
      setProjectList([]);

    }
  };



  const isAnyFilterActive =
    filters.projectManagerId !== "-1" ||
    filters.projectNumber !== "-1" ||
    filters.projectName !== "-1" ||
    filters.clientId !== "-1" ||
    filters.startDate !== null ||
    filters.endDate !== null;


  // ✅ Fetch current baseline from API
  const fetchCurrentBaseline = async (projectManagerId: number) => {
    try {
      const { data } = await execute<ProjectBaselineResponse>(
        "get",
        `ProjectBaseline/current/${projectManagerId}`
      );

      if (data) {

        // ✅ Set entire response in state
        setCurrentBaseline(data.projectBaseline);
      } else {
        setCurrentBaseline(null);
      }
    } catch (error) {
      console.error("Error fetching current baseline", error);
      setCurrentBaseline(null);
    }
  };

  // ------------------- Populate dropdowns and table on page load -------------------
  useEffect(() => {
    const fetchData = async () => {
      const payload: ProjectListingFilterModel = {
        //projectManagerId: userId,
        projectManagerId: isProjectManager ? userId : 0,
        projectNumber: null,
        projectName: null,
        startDate: null,
        endDate: null,
        clientId: 0,
        isAdmin: isAllowAcessProjects,
      };

      try {
        const { data } = await execute("post", "Dashboard/GetProjectListing", payload);
        console.log("DashBoardListing", data)
        if (data && Array.isArray(data)) {
          // ---------- Populate Dropdowns ----------
          const projectNumbers = Array.from(new Set(data.map((p: any) => p.projectNumber || "")))
            .filter((p) => p)
            .map((p) => ({ value: p, text: p }));

          const projectNames = Array.from(new Set(data.map((p: any) => p.projectName || "")))
            .filter((p) => p)
            .map((p) => ({ value: p, text: p }));

          const clients = Array.from(
            new Set(
              data
                .map((p: any) =>
                  p.clientId && p.clientName
                    ? JSON.stringify({ id: p.clientId, name: p.clientName })
                    : null
                )
                .filter(Boolean)
            )
          ).map((c) => {
            const obj = JSON.parse(c as string);
            return { value: obj.id, text: obj.name };
          });
          const projectManagers = Array.from(
            new Set(
              data
                .map((p: any) =>
                  p.projectManagerId && p.projectManagerName
                    ? JSON.stringify({ id: p.projectManagerId, name: p.projectManagerName })
                    : null
                )
                .filter(Boolean)
            )
          ).map((pm) => {
            const obj = JSON.parse(pm as string);
            return { value: obj.id, text: obj.name };
          });

          setDropdownOptions({ projectNumbers, projectNames, clients, projectManagers });

          // ---------- Populate Table ----------
          const mapped = data.map((item: any) => ({
            projectId: item.projectId,
            projectNumber: item.projectNumber,
            projectName: item.projectName,
            projectManagerId: item.projectManagerId,
            projectManagerName: item.projectManagerName,
            totalChangeDefinite: item.totalDefiniteChange,
            totalChangeProposed: item.totalProposedChange,
            totalChangeThirdParty: item.totalThirdPartyChange,
            totalChangeOverall: item.totalDefiniteChange + item.totalProposedChange,
            baselineProjectStatus: item.baselineProjectStatus,
            baselineStatus: item.baselineStatus,
            startDate: item.startDate,
            endDate: item.endDate
          }));

          setProjectList(mapped);

          if (data.length > 0) {
            if (!isAdmin)
              await fetchCurrentBaseline(userId);
          }
        }
      } catch (error) {
        console.error("Error fetching project listing", error);
      }
    };

    fetchData();
  }, [execute, userId, isAdmin]);

  // ------------------- Fetch project list on Search -------------------
  const handleSearch = async () => {
    const query = searchQuery.trim() === "" ? null : searchQuery.trim();

    const payload: ProjectListingFilterModel = {
      projectManagerId: (isProjectManager ? userId : Number(filters.projectManagerId) === -1
        ? 0 : Number(filters.projectManagerId)),
      projectNumber: query,
      projectName: query,
      clientId: filters.clientId !== "-1" ? Number(filters.clientId) : 0,
      startDate: formatDate(filters.startDate), // send only date
      endDate: formatDate(filters.endDate),     // send only date
      isAdmin: isAdmin,
    };

    try {
      const { data } = await execute("post", "Dashboard/GetProjectListing", payload);

      if (data && Array.isArray(data)) {
        setProjectList(
          data.map((item: any) => ({
            projectId: item.projectId,
            projectNumber: item.projectNumber,
            projectName: item.projectName,
            projectManagerId: item.projectManagerId,
            projectManagerName: item.projectManagerName,
            totalChangeDefinite: item.totalDefiniteChange,
            totalChangeProposed: item.totalProposedChange,
            totalChangeThirdParty: item.totalThirdPartyChange,
            totalChangeOverall: item.totalDefiniteChange + item.totalProposedChange,
            baselineProjectStatus: item.baselineProjectStatus,
            baselineStatus: item.baselineStatus,
            clientId: item.clientId,
            clientName: item.clientName,
            startDate: item.startDate,
            endDate: item.endDate
          }))
        );
        await fetchCurrentBaseline(payload.projectManagerId);
      } else {
        // ✅ No data or null → clear list
        setProjectList([]);
      }
      setSearchExecuted(true);
    } catch (error) {
      console.error("Error fetching project listing", error);
      setProjectList([]);
      setSearchExecuted(false);
    }
  };


  const handleCreateBaseline = async () => {
    let isNavigate = true;

    try {
      let newBaselineId = 0;

      if (currentBaseline !== null && currentBaseline.id === 0) {
        const projectBaseline: ProjectBaseline = {
          id: 0,
          projectManagerID: userId,
          baseLineDate: new Date().toISOString(),
          createdID: userId,
          createdDate: new Date().toISOString(),
          status: ProjectBaselineStatus.Created,
          comments: "Initial baseline save"
        };

        const payload = {
          ProjectBaseline: projectBaseline,
          BaselineDetails: [] as BaselineDetailRequest[],
        };

        const { data } = await execute<SaveBaselineResponse>("post", "/ProjectBaseline/Save", payload);

        newBaselineId = data?.baselineID ?? 0;

        if (!newBaselineId || newBaselineId <= 0) {
          isNavigate = false;
          console.error("Error: Baseline creation failed");
        } else {
          setCurrentBaseline({ ...projectBaseline, id: newBaselineId });
        }
      }
      else {
        newBaselineId = currentBaseline?.id ?? 0;
      }

      if (isNavigate) {
        navigate("/create-baseline", {
          state: {
            currentBaselineId: newBaselineId, // ✅ Pass baseline ID
          },
        });
      } else {
        setToast({
          open: true,
          message: "Baseline creation failed. Please try again.",
          type: "error",
        });
      }
    } catch (error) {
      console.error("Error in creating baseline", error);
      setToast({
        open: true,
        message: "Something went wrong while skipping the baseline.",
        type: "error",
      });
    }
  };


  // ------Colums-------
  const dashboardColumns: GridColDef[] = [
    {
      field: "projectNumber",
      headerName: "Project No",
      flex: 1,
    },
    {
      field: "projectName",
      headerName: "Project Name",
      flex: 1.5,
    },
    ...(isAllowAcessProjects
      ? [
        {
          field: "projectManagerName",
          headerName: "Project Manager",
          flex: 1.2,
        },
      ]
      : []),
    {
      field: "correct",
      headerName: "Correct/Not Correct",
      flex: 1,
      renderCell: (params) => {
        const row = params.row;
        const isIncorrect =
          row.totalChangeDefinite !== 0 ||
          row.totalChangeProposed !== 0 ||
          row.totalChangeThirdParty !== 0;

        return (
          <Tooltip title={isIncorrect ? "Incorrect" : "Correct"}>
            <Box>
              {isIncorrect ? "❌" : "✅"}
            </Box>
          </Tooltip>
        );
      },
    },
    {
      field: "totalChangeDefinite",
      headerName: "(Definite) Change",
      flex: 1,
      renderCell: (params) => params.value?.toLocaleString() ?? 0
    },
    {
      field: "totalChangeProposed",
      headerName: "(Proposed) Change",
      flex: 1,
      renderCell: (params) => params.value?.toLocaleString() ?? 0
    },
    {
      field: "totalChangeThirdParty",
      headerName: "(Third Party) Change",
      flex: 1,
      renderCell: (params) => params.value?.toLocaleString() ?? 0
    },
    {
      field: "baselineProjectStatus",
      headerName: "Status",
      flex: 1.2,
      renderCell: (params) => {
        const statusValue = params.value ?? ProjectBaselineStatus.Open;
        const label = ProjectBaselineDescriptions[statusValue] || "Open";
        const themeColor = statusColors[statusValue] || "#9333EA";

        return (
          <Chip
            label={label}
            size="small"
            sx={{

              backgroundColor: `${themeColor}20`,
              color: themeColor,
              border: `1px solid ${themeColor}`,
              fontWeight: 600,
              fontSize: "11px",
              height: "24px",
            }}
          />
        );
      },
    },
  ];

  // ------------------- Render -------------------
  return (
    <AppLayout>
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
        <Box sx={{ flexShrink: 0 }}>
          <Typography
            sx={headingStyles}
          >
            Dashboard
          </Typography>
        </Box>

        {/* <hr
          style={{
            backgroundColor: "#96c121",
            height: "2px",
            border: "none",
            marginBottom: "20px",
          }}
        /> */}

        {(isAllowAcessProjects || isProjectManager) && (
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
            {/* Filters */}
            <Paper elevation={0} sx={{ border: '1px solid #e0eaf6', borderRadius: '14px', overflow: 'hidden', mb: 2, flexShrink: 0 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, backgroundColor: '#f0f6ff', borderBottom: '1px solid #e0eaf6' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <FilterListOutlined sx={{ fontSize: 18, color: '#1e66ab' }} />
                  <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1e66ab', fontFamily: 'Poppins' }}>
                    Filters
                  </Typography>
                </Box>
              </Box>
              <Grid2
                container
                spacing={1.5}
                alignItems="center"
                sx={{
                  flexWrap: "wrap",
                  gap: 1,
                  display: "flex",
                  flexDirection: "row",
                  padding: '12px 20px 28px 20px',
                  backgroundColor: '#f7faff'
                }}
              >
                {/* ── Section label: Search and Filter ── */}
                <Grid2 size={{ xs: 12 }}>
                  <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.8px', fontFamily: 'Poppins', }}>
                    Search & Filter
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 8, md: 5 }}>

                  <SearchBar
                    placeholder="Search Project Number or Name"
                    onQueryChange={(val) => {
                      setSearchQuery(val);
                      handleFilterChange("projectName", val);
                    }}
                    onKeyDown={(e) => { if (e.key === "Enter") handleSearch(); }}
                    sx={{ backgroundColor: 'white', borderRadius: '8px', boxShadow: 'none', border: '1px solid #dde6f4' }}
                  />
                </Grid2>

                {/* --- Client --- */}
                <Grid2 size={{ xs: 6, sm: 4, md: 2 }}>
                  <CustomDropdown
                    label="Associated Client"
                    value={filters.clientId}
                    onChange={(e) => handleFilterChange("clientId", e)}
                    options={dropdownOptions.clients}
                    sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                  />
                </Grid2>

                {/* --- Admin Only: Project Manager Filter --- */}
                {isAllowAcessProjects && (
                  <Grid2 size={{ xs: 6, sm: 4, md: 2 }}>
                    <CustomDropdown
                      label="Project Manager"
                      value={filters.projectManagerId}
                      onChange={(e) => handleFilterChange("projectManagerId", e)}
                      options={dropdownOptions.projectManagers}
                      sx={{ backgroundColor: 'white', borderRadius: '8px' }}
                    />
                  </Grid2>
                )}



                {/* --- Buttons --- */}
                <Grid2 size={{ xs: 12, sm: 'auto' }} sx={{ ml: 'auto' }}>
                  <Stack direction="row" spacing={1}>
                    <CustomButton
                      capsule
                      sx={{ textTransform: 'none', height: '40px', px: 3, whiteSpace: 'nowrap' }}
                      disabled={!isAnyFilterActive}
                      onClick={handleSearch}
                      backgroundColor="#1e66ab"
                      hoverColor="rgba(150, 193, 33, 0.75)"
                    >
                      <SearchIcon /> Search
                    </CustomButton>
                  </Stack>

                </Grid2>

                <Grid2>
                  <CustomButton
                    capsule
                    onClick={handleClearFilters}
                    backgroundColor={isAnyFilterActive ? "#1e66ab" : "#f0f0f0"}
                    disabled={!isAnyFilterActive}
                    sx={{
                      color: isAnyFilterActive ? "#fff" : "#1e66ab",
                      textTransform: 'none',
                      height: '40px',
                      px: 3,
                      whiteSpace: 'nowrap'
                    }}
                    hoverColor="rgba(150, 193, 33, 0.75)"
                  >
                    Clear All
                  </CustomButton>
                </Grid2>
              </Grid2>

            </Paper>

            {/* Buttons Row - All Right Aligned */}
            <Grid2 container justifyContent="flex-end" alignItems="center" sx={{mb :2 }}>
              <Box sx={{ display: "flex", gap: 2 }}>
                {((isProjectManager && projectList.length > 0) || (filters.projectManagerId !== "-1" && searchExecuted && projectList.length > 0)) && (
                  <CustomButton
                    capsule
                    onClick={handleViewBaseline}
                    backgroundColor="#1e66ab"
                    disabled={
                      !(
                        currentBaseline &&
                        currentBaseline.id > 0 &&
                         currentBaseline.status !== ProjectBaselineStatus.Created
                      )
                    }
                    hoverColor="rgba(150, 193, 33, 0.75)"
                    sx={{
                      color: "#fff",
                      textTransform: 'none',
                      height: '40px',
                      px: 3,
                      whiteSpace: 'nowrap'
                    }}
                  >
                    View Baseline
                  </CustomButton>
                )}

                {(filters.projectManagerId !== "-1" && searchExecuted && projectList.length > 0) && (
                  <CustomButton
                    capsule
                    backgroundColor="#1e66ab"
                    onClick={() => handleSkip("BL")}
                    disabled={
                      !(
                        currentBaseline &&
                        currentBaseline.id > 0 &&
                        currentBaseline.status === ProjectBaselineStatus.AwaitingReviewbyCommercialLead
                      )
                    }
                    hoverColor="rgba(150, 193, 33, 0.75)"
                    sx={{
                      color: "#fff",
                      textTransform: 'none',
                      height: '40px',
                      px: 3,
                      whiteSpace: 'nowrap'
                    }}
                  >
                    Skip BL
                  </CustomButton>
                )}
                {(isSMT && filters.projectManagerId !== "-1" && searchExecuted && projectList.length > 0) && (
                  <CustomButton
                    capsule
                    backgroundColor="#1e66ab"
                    onClick={() => handleSkip("CBL")}
                    disabled={
                      !(
                        currentBaseline &&
                        currentBaseline.id > 0 &&
                        currentBaseline.status === ProjectBaselineStatus.AwaitingReviewbyCommercialLead
                      )
                    }
                    hoverColor="rgba(150, 193, 33, 0.75)"
                    sx={{
                      color: "#fff",
                      textTransform: 'none',
                      height: '40px',
                      px: 3,
                      whiteSpace: 'nowrap'
                    }}
                  >
                    Skip CBL
                  </CustomButton>

                )}
                {(isProjectManager && projectList.length > 0) && (
                  <CustomButton
                    capsule
                    onClick={handleCreateBaseline}
                    backgroundColor="#1e66ab"
                    disabled={
                      !(
                        currentBaseline == null ||
                        currentBaseline.id === 0 ||
                        [
                          ProjectBaselineStatus.Created,
                          ProjectBaselineStatus.RejectedbyCommercialLead,
                          ProjectBaselineStatus.RejectedbySMT,
                          ProjectBaselineStatus.PartiallyApproved
                        ].includes(currentBaseline?.status)
                      )



                    }
                    hoverColor="rgba(150, 193, 33, 0.75)"
                    sx={{ color: "#fff", px: 3, whiteSpace: "nowrap" }}
                  >
                    {currentBaseline?.id === 0 || currentBaseline == null
                      ? "Create Baseline"
                      : "Edit Baseline"}
                  </CustomButton>
                )}
              </Box>
            </Grid2>



            <Box sx={{
              flex: 1,             
              // minHeight: 0,          
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden'    
            }}>
              {/* Table */}
              <CustomDashboardTable
                sortOptions={sortOptions}
                rows={projectList}
                columns={dashboardColumns}
                loading={loading}
              // gridHeight="550px"
              />
            </Box>
          </Box>

        )}

      </Box>

      <Toaster
        open={toast.open}
        message={toast.message}
        type={toast.type as "success" | "error"}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
      />
    </AppLayout>
  );
};

export default Dashboard;
